import { jsxs as d, jsx as s, Fragment as k } from "react/jsx-runtime";
import { useState as M, useMemo as Z, useEffect as le, useReducer as We, useRef as Xe, useCallback as Je, createElement as Ze, Fragment as qe } from "react";
import { IconNames as S } from "@blueprintjs/icons";
import { formatDate as V, DateFormats as $, conditionalString as J, sortDateAsc as Me, capitalizeString as de, formatNameFirstLast as Pe } from "@strata/helper-functions";
import { ActionButtonText as ae, Button as K } from "@strata/react-buttons";
import { ActionButtonTextDropdownMenu as es, DropdownMenu as q } from "@strata/react-dropdown-menu";
import { FormSection as we } from "@strata/react-form-section";
import { DetailLabelValuePair as Q } from "@strata/react-label-value-pairs";
import { MessagingBlock as ce } from "@strata/react-messaging-block";
import { Icon as h, FIcon as xe } from "@strata/react-status-icons";
import N from "classnames";
import _e from "dayjs";
import he from "react-animate-height";
import { PayerRequestStatusIndicator as re } from "@strata/react-status-indicators";
import { useResizeDetector as ss } from "react-resize-detector";
import { DialogWithForm as Le, WarningDialog as ts } from "@strata/react-dialog";
import { TextAreaFormik as as, TextInputFormik as ns, TextInput as is } from "@strata/react-inputs";
import { validationStrings as ue } from "@strata/strata-ui-strings";
import { Formik as ge } from "formik";
import * as ne from "yup";
import "./main.scss";
import { CollapsibleSidebarAndMainContent as Fe } from "@strata/react-collapsible-sidebar-and-main-content";
import { Search as os } from "@strata/react-filter-pane";
import ls from "@strata/strata-ui/assets/illustrations/conversation.svg";
import ds from "@strata/strata-ui/assets/illustrations/new-conversation.svg";
import cs from "@strata/strata-ui/assets/illustrations/new-note.svg";
import _s from "@strata/strata-ui/assets/illustrations/note.svg";
import { Icon as rs } from "@blueprintjs/core";
import { Hyperlink as ye } from "@strata/react-hyperlink";
import { FileUploadFormik as Re } from "@strata/react-file-upload";
import { Tooltip as ms } from "@strata/react-tooltip";
const Ce = {
  ERROR: "error",
  SUCCESS: "success",
  NONE: void 0
}, A = ({
  content: e,
  isTimeStamp: t = !1,
  intent: a = Ce.NONE
}) => {
  let l = e;
  return t && (l = _e(e).isSame(_e(), "day") ? "Today" : V(e, $.DATE_LONG)), /* @__PURE__ */ d("div", { className: "sds_chat__messages__separator", children: [
    /* @__PURE__ */ s("span", { className: "sds_chat__messages__separator__divider" }),
    /* @__PURE__ */ s(
      "div",
      {
        className: N("sds_chat__messages__separator__text-box", {
          [`sds_chat__messages__separator__text-box--${a}`]: a
        }),
        children: l
      }
    ),
    /* @__PURE__ */ s("span", { className: "sds_chat__messages__separator__divider" })
  ] });
};
A.Intent = Ce;
const X = {
  ESCALATION: "ESCALATION",
  CHANGE: "CHANGE",
  OTHER: "OTHER",
  ARCHIVE: "ARCHIVE"
}, _t = {
  [X.ESCALATION]: "Member Inquiry",
  [X.CHANGE]: "Change Management",
  [X.OTHER]: "Other",
  [X.ARCHIVE]: "Archive"
}, fe = {
  PHARMACY: "Pharmacy Management",
  PRODUCT: "Product Management",
  PROGRAM: "Program Management",
  ROUTE: "Route Management",
  OTHER: "Other"
}, rt = {
  CONFIRM_MEMBER_COVERAGE: "Confirm Member Coverage",
  EXPEDITE_MEMBER_REQUEST: "Expedite Member Request",
  REQUEST_MEMBER_STATUS: "Request Member Status",
  REQUEST_RATE_REVIEW: "Request Rate Review",
  REQUEST_REASSIGNMENT: "Request Reassignment",
  RESOLVE_AUTH_DATA_ISSUE: "Resolve Authorization Data Issue",
  RESOLVE_CLAIM_REJECTION: "Resolve Claim Rejection",
  RESOLVE_MEMBER_ISSUE: "Resolve Member Issue",
  OTHER: "Other"
}, m = {
  MESSAGE: "MESSAGE",
  APPROV_REQ: "APPROV_REQ",
  APPROV_DEN: "APPROV_DEN",
  APPROVED: "APPROVED",
  RESOLVED: "RESOLVED",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
  ASSIGN_UP: "ASSIGN_UP",
  ASSIGN_CL: "ASSIGN_CL",
  DETAIL_UP: "DETAIL_UP",
  SUMMARY_UP: "SUMMARY_UP",
  FILE_ADDED: "FILE_ADDED",
  REOPEN: "REOPEN"
}, Ve = (e) => e.requestStatus === re.Statuses.COMPLETED || e.requestStatus === re.Statuses.CANCELED, O = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  ARCHIVED: "ARCHIVED"
}, ps = [O.OPEN, O.CLOSED], me = {
  NORMAL: "NORMAL",
  SYSTEM: "SYSTEM"
}, ie = {
  // Conversations
  [O.OPEN]: {
    statusChangeAction: "close",
    statusChangeActionName: "close",
    currentStatus: "Opened",
    descriptor: "open",
    lastStatus: "Created",
    lastStatusTimestampKey: "createdTime",
    lastStatusFirstNameKey: "createdByFirstName",
    lastStatusLastNameKey: "createdByLastName",
    intent: A.Intent.NONE
  },
  [O.CLOSED]: {
    statusChangeAction: "open",
    statusChangeActionName: "reopen",
    currentStatus: "Closed",
    descriptor: "closed",
    lastStatus: "Closed",
    lastStatusTimestampKey: "closedTime",
    lastStatusFirstNameKey: "closedByFirstName",
    lastStatusLastNameKey: "closedByLastName",
    intent: A.Intent.ERROR
  },
  [O.ARCHIVED]: {
    currentStatus: "Archived",
    lastStatus: "Archived",
    lastStatusTimestampKey: "archivedTime",
    lastStatusFirstNameKey: "archivedByFirstName",
    lastStatusLastNameKey: "archivedByLastName",
    intent: A.Intent.ERROR
  },
  // Payer Requests
  [m.APPROVED]: {
    currentStatus: "Approved",
    intent: A.Intent.SUCCESS
  },
  [m.RESOLVED]: {
    currentStatus: "Resolved",
    intent: A.Intent.SUCCESS
  },
  [m.COMPLETED]: {
    currentStatus: "Closed",
    intent: A.Intent.SUCCESS
  },
  [m.CANCELED]: {
    currentStatus: "Canceled",
    intent: A.Intent.ERROR
  },
  [m.ASSIGN_UP]: {
    currentStatus: "FMH assignee updated to",
    intent: A.Intent.NONE
  },
  [m.ASSIGN_CL]: {
    currentStatus: "Payer assignee updated to",
    intent: A.Intent.NONE
  },
  [m.DETAIL_UP]: {
    currentStatus: "Request details updated",
    intent: A.Intent.NONE
  },
  [m.SUMMARY_UP]: {
    currentStatus: "Summary updated",
    intent: A.Intent.NONE
  },
  [m.FILE_ADDED]: {
    currentStatus: "File added",
    intent: A.Intent.NONE
  },
  [m.REOPEN]: {
    currentStatus: "Reopened",
    intent: A.Intent.SUCCESS
  }
}, W = {
  CHAT: "CHAT",
  NOTES: "NOTES"
}, us = (e) => {
  const [t, a] = e.reduce(
    ([l, i], n) => [
      [...l, ...n.conversationStatus === O.OPEN ? [n] : []],
      [
        ...i,
        ...n.conversationStatus === O.CLOSED ? [n] : []
      ]
    ],
    [[], []]
  );
  return {
    [O.OPEN]: t,
    [O.CLOSED]: a
  };
}, Ns = (e, t) => {
  if (t) {
    const a = us(e);
    return {
      defaultConversation: a[O.OPEN][0] ?? a[O.CLOSED][0],
      groups: a
      // TODO: https://github.com/microsoft/TypeScript/issues/23132
    };
  }
  return { defaultConversation: e[0] };
}, ve = (e, t) => e && !e.includes("T") ? 1 : t && !t.includes("T") ? -1 : Me(e, t), hs = (e) => {
  const t = {};
  return e == null || e.sort((a, l) => ve(a.sentTime, l.sentTime)).forEach((a) => {
    const l = a.sentTime, i = V(l, $.DATE_LONG);
    t[i] = [...t[i] ?? [], a];
  }), t;
}, $e = (e, t) => e && t || !(e || t), ee = (e, t) => `${J(!!e, `${e} `)}${t ?? ""}`, Se = ({ message: e = void 0 }) => {
  var c, p, g;
  const [t, a] = M(!1), [l, i] = M(), n = ss(), _ = Z(
    () => {
      var T, y;
      return (((T = n.ref.current) == null ? void 0 : T.clientHeight) ?? 0) < (((y = n.ref.current) == null ? void 0 : y.scrollHeight) ?? 0);
    },
    [n]
  ), u = l ? (((c = n.ref.current) == null ? void 0 : c.scrollHeight) ?? 0) >= l : !1;
  return /* @__PURE__ */ d(k, { children: [
    /* @__PURE__ */ s(
      he,
      {
        "data-testid": "animate-height",
        duration: 300,
        height: (t ? (p = n.ref.current) == null ? void 0 : p.scrollHeight : (g = n.ref.current) == null ? void 0 : g.clientHeight) ?? "auto",
        children: /* @__PURE__ */ s(
          "div",
          {
            className: N("sds_chat__message__content__text", {
              "sds_chat__message__content__text--clamped": !t
            }),
            ref: n.ref,
            children: e
          }
        )
      }
    ),
    (_ || u) && /* @__PURE__ */ s(
      "div",
      {
        className: "padding__top--x-small",
        style: { display: "flex", justifyContent: "right" },
        children: /* @__PURE__ */ s(
          ae,
          {
            label: t ? "Show Less" : "Show More",
            rightIcon: /* @__PURE__ */ s(
              h,
              {
                className: N("sds_button-with-menu__chevron", {
                  "sds_button-with-menu__chevron--up": t
                }),
                icon: S.CHEVRON_DOWN
              }
            ),
            onClick: () => {
              var T;
              i((T = n.ref.current) == null ? void 0 : T.scrollHeight), a((y) => !y);
            }
          }
        )
      }
    )
  ] });
}, gs = ({
  isOpen: e,
  onClose: t,
  onApprovalComplete: a
}) => {
  const l = ne.object({
    actionDetail: ne.string().required(ue.requiredField.errorMessage)
  });
  return /* @__PURE__ */ s(
    ge,
    {
      initialValues: {},
      enableReinitialize: !0,
      validateOnMount: !0,
      validationSchema: l,
      onSubmit: async (i, { resetForm: n }) => {
        await a({
          actionTaken: m.APPROV_DEN,
          actionDetail: i.actionDetail
        }), n(), t();
      },
      children: (i) => /* @__PURE__ */ s(
        Le,
        {
          dialogTitle: "Deny Approval",
          isOpen: e,
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: () => {
            t(), i.resetForm();
          },
          primaryButtonLabel: "Deny Approval",
          primaryButtonIntent: K.Intent.DANGER,
          isPrimaryButtonDisabled: !i.isValid || i.isSubmitting,
          dialogContent: /* @__PURE__ */ s(
            as,
            {
              id: "actionDetail",
              label: "Please Provide A Reason For Denying The Approval",
              required: !0
            }
          )
        }
      )
    }
  );
}, Ee = ({
  firstName: e = void 0,
  lastName: t = void 0,
  className: a = void 0,
  image: l = void 0
}) => /* @__PURE__ */ s("div", { className: N("sds_chat__user-image", a), children: l ?? ((e == null ? void 0 : e[0]) ?? "") + ((t == null ? void 0 : t[0]) ?? "") }), vs = {
  [m.APPROV_REQ]: S.HELP,
  [m.APPROV_DEN]: S.CROSS
}, Ss = {
  [m.APPROV_REQ]: "Approval Requested",
  [m.APPROV_DEN]: "Approval Denied"
}, Oe = {
  [m.APPROV_REQ]: h.Intent.WARNING,
  [m.APPROV_DEN]: h.Intent.ERROR
}, Es = ({
  senderFirstName: e,
  senderLastName: t,
  content: a,
  sentTime: l,
  onApprovalComplete: i = void 0,
  isLatestApprovalMessage: n,
  disabled: _,
  isSupportMsg: u = !1,
  isSupportUser: c = !1
}) => {
  const [p, g] = M(!1);
  return /* @__PURE__ */ d(
    "div",
    {
      className: N(
        "sds_chat__message",
        "sds_chat__message--partial-width",
        "sds_chat__message--approval",
        {
          "sds_chat__message--align-right": $e(c, u)
        }
      ),
      children: [
        /* @__PURE__ */ s("div", { className: "sds_chat__message__user", children: /* @__PURE__ */ s(
          Ee,
          {
            image: /* @__PURE__ */ s(
              h,
              {
                size: 24,
                icon: vs[a.status],
                intent: Oe[a.status]
              }
            ),
            className: "sds_chat__user-image--approval"
          }
        ) }),
        /* @__PURE__ */ d(
          "div",
          {
            className: N(
              "sds_chat__message__container",
              "sds_chat__message__container--approval"
            ),
            children: [
              /* @__PURE__ */ d(
                "div",
                {
                  className: "flex__gap--large margin__bottom--x-small",
                  style: { alignItems: "center" },
                  children: [
                    /* @__PURE__ */ s(
                      "span",
                      {
                        className: N(
                          "sds_chat__message__user__name",
                          "sds_chat__message__user__name--approval",
                          `sds_chat__message__user__name--${Oe[a.status]}`
                        ),
                        children: Ss[a.status]
                      }
                    ),
                    /* @__PURE__ */ s("span", { className: "sds_chat__message__timestamp__value", children: `${V(l, $.TIME)} by ${ee(
                      e,
                      t
                    )}` })
                  ]
                }
              ),
              /* @__PURE__ */ s(Se, { message: a.message })
            ]
          }
        ),
        i && n && a.status === m.APPROV_REQ && /* @__PURE__ */ d("div", { className: "flex__gap--medium", children: [
          /* @__PURE__ */ s(
            gs,
            {
              isOpen: p,
              onClose: () => g(!1),
              onApprovalComplete: i
            }
          ),
          /* @__PURE__ */ s(
            K,
            {
              label: "Deny",
              intent: K.Intent.DANGER,
              disabled: _,
              onClick: () => g(!0)
            }
          ),
          /* @__PURE__ */ s(
            K,
            {
              label: "Approve",
              intent: K.Intent.PRIMARY,
              disabled: _,
              onClick: () => {
                i({
                  actionTaken: m.APPROVED
                });
              }
            }
          )
        ] })
      ]
    }
  );
}, Is = ne.object({
  message: ne.string().required()
}), As = ({
  conversationId: e,
  onMessageSend: t,
  dispatchConversationMessage: a,
  conversationMessage: l = void 0,
  mentionOnClick: i = void 0,
  attachOnClick: n = void 0,
  chatDisabled: _ = !1,
  childInstanceName: u = void 0
}) => /* @__PURE__ */ s("div", { className: "sds_chat__editor-area", children: /* @__PURE__ */ s(
  ge,
  {
    onSubmit: async (c, { resetForm: p }) => {
      await t({
        conversationId: e,
        details: {
          message: c.message
        }
      }), a({
        conversationId: e,
        reset: !0
      }), p();
    },
    initialValues: (l == null ? void 0 : l[e]) ?? {},
    validationSchema: Is,
    validateOnMount: !0,
    enableReinitialize: !0,
    children: (c) => /* @__PURE__ */ d(k, { children: [
      /* @__PURE__ */ s(
        ns,
        {
          id: "message",
          placeholderText: `Type a new ${u}`,
          verticalSpacingSmall: !0,
          disabled: _,
          onChange: (p) => {
            (async () => {
              const { value: g } = p.target;
              await c.setFieldValue("message", g), a({
                conversationId: e,
                messageValue: g
              });
            })();
          },
          requiredValidationMessage: ""
        }
      ),
      /* @__PURE__ */ d("div", { className: "sds_chat__editor-bar", children: [
        /* @__PURE__ */ d("div", { className: "flex__gap--small", children: [
          i && /* @__PURE__ */ s(
            h,
            {
              icon: S.AT,
              intent: h.Intent.SECONDARY,
              size: 20,
              className: N("sds_chat__button", {
                "sds_chat__button--disabled": _
              }),
              onClick: () => i({ formik: c }),
              title: "Mention"
            }
          ),
          n && /* @__PURE__ */ s(
            h,
            {
              icon: S.PAPERCLIP,
              intent: h.Intent.SECONDARY,
              size: 20,
              className: N("sds_chat__button", {
                "sds_chat__button--disabled": _
              }),
              onClick: () => n({ formik: c }),
              title: "Attach"
            }
          )
        ] }),
        /* @__PURE__ */ s(
          h,
          {
            icon: S.SEND_MESSAGE,
            size: 20,
            onClick: () => c.handleSubmit(),
            className: N("sds_chat__button", {
              "sds_chat__button--disabled": _ || !c.isValid,
              "sds_chat__button--primary": c.isValid
            }),
            title: "Send Message"
          }
        )
      ] })
    ] })
  }
) }), Ts = ({ link: e }) => {
  const [t, a] = M(!1);
  return le(() => {
    const l = setTimeout(() => {
      t && a(!1);
    }, 3e3);
    return () => clearTimeout(l);
  }, [t]), /* @__PURE__ */ d("div", { style: { display: "flex" }, children: [
    /* @__PURE__ */ s("div", { style: { flexGrow: 1 }, children: /* @__PURE__ */ s(is, { disabled: !0, id: "link", name: "link", value: e }) }),
    /* @__PURE__ */ s(
      K,
      {
        label: t ? "Copied!" : "Copy Link",
        onClick: () => {
          (async () => {
            try {
              await navigator.clipboard.writeText(e), a(!0);
            } catch (l) {
              console.error("Error writing to clipboard.", l);
            }
          })();
        },
        className: N("sds_chat__details__copy-button", {
          "sds_chat__details__copy-button--clicked": t
        })
      }
    )
  ] });
}, ys = (e, { conversationId: t, messageValue: a = "", reset: l = !1 }) => l ? {
  ...e,
  [t]: void 0
} : {
  ...e,
  [t]: {
    message: a
  }
}, He = ({
  currentChat: e = void 0,
  onMessageSend: t,
  onMessageDelete: a = void 0,
  onApprovalComplete: l,
  messageContainer: i,
  mentionOnClick: n,
  attachOnClick: _,
  chatDisabled: u = !1,
  newInstanceImage: c = void 0,
  newInstancePrimaryText: p = void 0,
  newInstanceSecondaryText: g = void 0,
  childInstanceName: T,
  isLoading: y = !1,
  userUPN: z = void 0,
  isSupportUser: x = void 0,
  showDateSeparators: L = !1,
  onConversationStatusChange: P = void 0,
  onChangeConversationType: D = void 0,
  onChangeAssignment: F = void 0,
  showViewDetailsButton: R = !1,
  chatLink: w = void 0
}) => {
  var Y, se, te, oe;
  const [H, C] = We(ys, {}), [I, U] = M(!1), f = Xe(null);
  le(() => {
    f != null && f.current && f.current.scrollTo(0, f.current.scrollHeight);
  }, [e]);
  const r = ((Y = e == null ? void 0 : e.messages) == null ? void 0 : Y.length) === 0 && c, B = Je(
    ({ messageType: b, ...o }, v, pe) => {
      var Ae;
      if (b === me.SYSTEM) {
        if (o.content.status === m.APPROV_REQ || o.content.status === m.APPROV_DEN)
          return /* @__PURE__ */ s(
            Es,
            {
              senderFirstName: o.senderFirstName,
              senderLastName: o.senderLastName,
              content: o.content,
              sentTime: o.sentTime,
              onApprovalComplete: l,
              isLatestApprovalMessage: v === pe.findLastIndex(
                (Qe) => [
                  m.APPROVED,
                  m.APPROV_REQ,
                  m.APPROV_DEN
                ].includes(Qe.content.status ?? "")
              ),
              disabled: u,
              isSupportMsg: o.isSupportMsg,
              isSupportUser: x
            },
            o.messageId
          );
        const { currentStatus: ke, intent: ze } = (o.content.status && ie[o.content.status]) ?? {}, Te = ee(
          o.senderFirstName,
          o.senderLastName
        ), Ye = J(!!Te, ` by ${Te}`), je = J(
          !!((Ae = o.content) != null && Ae.message),
          ` ${o.content.message}`
        ), Ke = `${ke}${je} on ${V(
          o.sentTime,
          $.DATE_TIME_LONG
        )}${Ye}`;
        return /* @__PURE__ */ s(
          A,
          {
            content: Ke,
            intent: ze
          },
          o.messageId
        );
      }
      return /* @__PURE__ */ Ze(
        i,
        {
          ...o,
          key: o.messageId,
          onDelete: a && (e != null && e.conversationId) ? () => {
            a({
              conversationId: e.conversationId,
              messageId: o.messageId
            });
          } : void 0,
          isSupportUser: x,
          isSentByActiveUser: o.upn === z
        }
      );
    },
    [
      e == null ? void 0 : e.conversationId,
      x,
      a,
      z,
      i,
      l,
      u
    ]
  ), j = Z(() => {
    const b = [...(e == null ? void 0 : e.messages) ?? []];
    return L ? Object.entries(hs(b)).sort(([o], [v]) => Me(o, v)).map(([o, v]) => /* @__PURE__ */ d(qe, { children: [
      !(e != null && e.createdTime) || !_e(e.createdTime).isSame(o, "day") && /* @__PURE__ */ s(A, { content: o, isTimeStamp: !0 }),
      v.map(B)
    ] }, o)) : (b.sort((o, v) => ve(o.sentTime, v.sentTime)), b.map(B));
  }, [
    L,
    B,
    e == null ? void 0 : e.messages,
    e == null ? void 0 : e.createdTime
  ]);
  le(() => {
    U(!1);
  }, [e == null ? void 0 : e.conversationId]);
  const E = e ? [
    ...P && e.conversationStatus ? [
      {
        text: de(
          `${(se = ie[e.conversationStatus]) == null ? void 0 : se.statusChangeActionName} Conversation`
        ),
        onItemClick: () => P(e.conversationId)
      }
    ] : [],
    ...D ? [
      {
        text: "Change Conversation Type",
        onItemClick: () => D(e.conversationId)
      }
    ] : [],
    ...F ? [
      {
        text: "Select/Change Assignment",
        onItemClick: () => F(
          e.conversationId,
          e.assignedUpn
        )
      }
    ] : []
  ] : [], G = Z(
    () => {
      var b;
      return Object.entries(((b = e == null ? void 0 : e.details) == null ? void 0 : b.data) ?? []).map(([o, v]) => /* @__PURE__ */ s(
        Q,
        {
          label: o,
          value: v,
          className: "padding__bottom--medium"
        },
        o
      ));
    },
    [(te = e == null ? void 0 : e.details) == null ? void 0 : te.data]
  );
  return /* @__PURE__ */ s(
    we,
    {
      sectionTitle: ((oe = e == null ? void 0 : e.details) == null ? void 0 : oe.subject) ?? "",
      isLoading: y,
      className: "sds_chat__window",
      rightHeaderContent: e && /* @__PURE__ */ d(
        "div",
        {
          className: "margin__left--small flex__gap--small",
          style: { alignItems: "center" },
          children: [
            E.length > 0 && /* @__PURE__ */ s(es, { label: "Actions", menuItems: E }),
            R && /* @__PURE__ */ s(
              ae,
              {
                label: "View Details",
                rightIcon: /* @__PURE__ */ s(
                  h,
                  {
                    className: N("sds_button-with-menu__chevron", {
                      "sds_button-with-menu__chevron--up": I
                    }),
                    icon: S.CHEVRON_DOWN
                  }
                ),
                onClick: () => U((b) => !b)
              }
            )
          ]
        }
      ),
      content: /* @__PURE__ */ d(k, { children: [
        R && /* @__PURE__ */ s(
          he,
          {
            "data-testid": "animate-height",
            duration: 300,
            height: I ? "auto" : 0,
            className: "sds_chat__details",
            children: /* @__PURE__ */ d("div", { className: "sds_chat__details__container", children: [
              /* @__PURE__ */ s("div", { className: "sds_chat__details__container--scroll", children: G }),
              /* @__PURE__ */ d("div", { style: { width: "40%" }, children: [
                x && /* @__PURE__ */ s(
                  Q,
                  {
                    label: "Assignment",
                    value: (e == null ? void 0 : e.assignedUpn) && Pe(
                      e == null ? void 0 : e.assignedFirstName,
                      e == null ? void 0 : e.assignedLastName
                    ),
                    className: "padding__bottom--medium"
                  }
                ),
                /* @__PURE__ */ s(
                  Q,
                  {
                    label: "Conversation ID",
                    value: e == null ? void 0 : e.displayId,
                    className: "padding__bottom--small"
                  }
                ),
                w && /* @__PURE__ */ s(Ts, { link: w })
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ d("div", { className: "sds_chat__window__conversation", children: [
          /* @__PURE__ */ d("div", { className: "sds_chat__messages", ref: f, children: [
            R && /* @__PURE__ */ d("div", { className: "sds_chat__messages__details", children: [
              /* @__PURE__ */ s("div", { className: "sds_chat__messages__details--title", children: "Conversation Details" }),
              G
            ] }),
            L && /* @__PURE__ */ s(
              A,
              {
                intent: A.Intent.SUCCESS,
                content: `Created on ${V(
                  e == null ? void 0 : e.createdTime,
                  $.DATE_TIME_LONG
                )} by ${ee(
                  e == null ? void 0 : e.createdByFirstName,
                  e == null ? void 0 : e.createdByLastName
                )}`
              }
            ),
            j,
            r && /* @__PURE__ */ s(
              ce,
              {
                icon: /* @__PURE__ */ s(
                  "img",
                  {
                    src: c,
                    alt: "New Instance",
                    loading: "lazy"
                  }
                ),
                size: ce.Sizes.SMALL,
                primaryText: p,
                secondaryText: g
              }
            )
          ] }),
          e && /* @__PURE__ */ s(
            As,
            {
              conversationId: e.conversationId,
              onMessageSend: t,
              dispatchConversationMessage: C,
              conversationMessage: H,
              mentionOnClick: n,
              attachOnClick: _,
              chatDisabled: u,
              childInstanceName: T
            }
          )
        ] })
      ] })
    }
  );
}, Rs = ({
  senderFirstName: e,
  senderLastName: t,
  content: a,
  sentTime: l,
  onDelete: i = void 0,
  isSupportMsg: n = !1,
  isSupportUser: _ = !1,
  isSentByActiveUser: u = !1
}) => {
  const [c, p] = M(!1), g = i ? [
    {
      text: "Delete Message",
      onItemClick: i,
      intent: q.Intent.DANGER
    }
  ] : [];
  return /* @__PURE__ */ d(
    "div",
    {
      className: N("sds_chat__message", "sds_chat__message--partial-width", {
        "sds_chat__message--align-right": $e(_, n)
      }),
      onMouseLeave: () => p(!1),
      children: [
        /* @__PURE__ */ s("div", { className: "sds_chat__message__user", children: !u && /* @__PURE__ */ s(
          Ee,
          {
            image: n ? /* @__PURE__ */ s(xe, { size: 24 }) : void 0,
            firstName: e,
            lastName: t,
            className: N({
              "sds_chat__user-image--support-msg": n
            })
          }
        ) }),
        /* @__PURE__ */ d(
          "div",
          {
            className: N("sds_chat__message__container", {
              "sds_chat__message__container--sent-by-active-user": u
            }),
            children: [
              /* @__PURE__ */ d("div", { className: "flex__gap--large margin__bottom--x-small", children: [
                !u && /* @__PURE__ */ s("span", { className: "sds_chat__message__user__name sds_chat__message__user__name--chat", children: ee(e, t) }),
                /* @__PURE__ */ s("span", { className: "sds_chat__message__timestamp__value", children: V(l, $.TIME) }),
                g.length > 0 && /* @__PURE__ */ s(
                  "div",
                  {
                    className: N("sds_chat__message__options", {
                      "sds_chat__message__options--show": c
                    }),
                    style: { flexGrow: 1 },
                    children: /* @__PURE__ */ s(
                      q,
                      {
                        isOpen: c,
                        menuItemArray: g,
                        onInteraction: (T, y) => {
                          y == null || y.stopPropagation(), p(T);
                        },
                        children: /* @__PURE__ */ s("div", { className: "sds_chat__ellipsis--border", children: /* @__PURE__ */ s(
                          h,
                          {
                            icon: S.MORE,
                            intent: h.Intent.SECONDARY,
                            title: "Message Menu",
                            className: "sds_chat__ellipsis"
                          }
                        ) })
                      }
                    )
                  }
                )
              ] }),
              /* @__PURE__ */ s(Se, { message: a.message })
            ]
          }
        )
      ]
    }
  );
}, fs = ({
  senderFirstName: e,
  senderLastName: t,
  content: a,
  sentTime: l,
  onDelete: i = void 0
}) => {
  const [n, _] = M(!1), u = _e().isSame(l, "day"), c = i ? [
    {
      text: "Delete Message",
      onItemClick: i,
      intent: q.Intent.DANGER
    }
  ] : [];
  return /* @__PURE__ */ d(
    "div",
    {
      className: "sds_chat__message sds_chat__message__container",
      onMouseLeave: () => _(!1),
      children: [
        /* @__PURE__ */ d("div", { className: "sds_chat__message__user sds_chat__message__user--note", children: [
          /* @__PURE__ */ s(
            Ee,
            {
              firstName: e,
              lastName: t,
              className: "margin__right--medium"
            }
          ),
          /* @__PURE__ */ s("div", { className: "sds_chat__message__user__name", children: Pe(e, t) })
        ] }),
        /* @__PURE__ */ s("div", { className: "sds_chat__message__content__container", children: /* @__PURE__ */ s(Se, { message: a.message }) }),
        /* @__PURE__ */ d("div", { className: "sds_chat__message__timestamp__container", children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: N(
                "sds_chat__message__timestamp__value",
                "sds_chat__message__timestamp__value--note"
              ),
              children: V(
                l,
                u ? $.TIME : $.DATE_MEDIUM
              )
            }
          ),
          c.length > 0 && /* @__PURE__ */ s(
            "div",
            {
              className: N("sds_chat__message__options", {
                "sds_chat__message__options--show": n
              }),
              children: /* @__PURE__ */ s(
                q,
                {
                  isOpen: n,
                  menuItemArray: c,
                  portalClassName: "sds_chat__options-dropdown",
                  onInteraction: (p, g) => {
                    g == null || g.stopPropagation(), _(p);
                  },
                  children: /* @__PURE__ */ s(
                    h,
                    {
                      icon: S.MORE,
                      intent: h.Intent.SECONDARY,
                      title: "Note Menu",
                      className: "sds_chat__ellipsis"
                    }
                  )
                }
              )
            }
          )
        ] })
      ]
    }
  );
}, Ue = {
  [W.CHAT]: {
    parentInstanceName: "conversation",
    parentInstanceIcon: S.CHAT,
    childInstanceName: "message",
    childContainer: Rs,
    newInstanceImage: ds,
    newInstancePrimaryText: (e) => e ? "FMH Support has created this conversation." : "Your conversation is started!",
    newInstanceSecondaryText: (e) => e ? "Type a message below to get started." : "Free Market Health Support will respond soon.",
    noInstanceImage: ls,
    noInstancePrimaryText: "No conversations yet!",
    noInstanceSecondaryText: "Create a conversation to get a question answered or a problem solved.",
    showDateSeparators: !0,
    groupByStatus: !0,
    onlyOpenStatuses: !1,
    showAssignee: !0
  },
  [W.NOTES]: {
    parentInstanceName: "notebook",
    parentInstanceIcon: S.ANNOTATION,
    childInstanceName: "note",
    childContainer: fs,
    newInstanceImage: cs,
    newInstancePrimaryText: () => "You're starting a new notebook.",
    newInstanceSecondaryText: () => "Type a note below to get started.",
    noInstanceImage: _s,
    noInstancePrimaryText: "No notebooks yet!",
    noInstanceSecondaryText: "Create a notebook to discuss referral questions or issues internally.",
    showDateSeparators: !1,
    groupByStatus: !1,
    onlyOpenStatuses: !0,
    showAssignee: !1
  }
}, Ne = {
  SMALL: "small",
  LARGE: "large"
}, Be = ({ size: e = Ne.SMALL, seen: t = !1 }) => /* @__PURE__ */ s(
  "div",
  {
    className: N("sds_chat__conversation-option__indicator", {
      "sds_chat__conversation-option__indicator--not-seen": !t,
      "sds_chat__conversation-option__indicator--large": e === Ne.LARGE
    })
  }
);
Be.sizes = Ne;
const De = (e, t) => {
  const a = t == null ? void 0 : t.replace(/[^a-z0-9 -]/gi, "."), l = new RegExp(`${a}`, "gi"), i = [...e.matchAll(l)], n = (_, u, c) => /* @__PURE__ */ d(k, { children: [
    /* @__PURE__ */ s("span", { className: "sds_chat__highlighted-text", children: c }),
    e.substring(
      u + c.length,
      typeof i[_ + 1] < "u" ? i[_ + 1].index : void 0
    )
  ] });
  return i.length === 0 || !a ? e : /* @__PURE__ */ s(k, { children: i.map(({ 0: _, index: u }, c) => /* @__PURE__ */ d("span", { children: [
    c === 0 && e.substring(0, u),
    n(c, u, _)
  ] }, _.concat(c.toString()))) });
}, Ge = ({
  conversationId: e,
  conversationStatus: t,
  parentInstanceName: a,
  details: l,
  selectedOption: i = void 0,
  onClick: n = void 0,
  isUnread: _,
  onDelete: u = void 0,
  onStatusChange: c = void 0,
  onChangeConversationType: p = void 0,
  onChangeAssignment: g = void 0,
  highlightText: T = void 0,
  isStatusChangePreview: y = !1,
  showAssignee: z = void 0,
  assignedUpn: x,
  assignedFirstName: L,
  assignedLastName: P,
  ...D
}) => {
  const [F, R] = M(!1), w = i === e, {
    statusChangeActionName: H,
    lastStatus: C,
    lastStatusTimestampKey: I,
    lastStatusFirstNameKey: U,
    lastStatusLastNameKey: f
  } = ie[t] ?? {}, r = [
    ...u ? [
      {
        text: de(`Delete ${a}`),
        onItemClick: () => u(e),
        intent: q.Intent.DANGER
      }
    ] : [],
    ...c ? [
      {
        text: de(`${H} ${a}`),
        onItemClick: () => c(e)
      }
    ] : [],
    ...p ? [
      {
        text: "Change Conversation Type",
        onItemClick: () => p(e)
      }
    ] : [],
    ...g ? [
      {
        text: "Select/Change Assignment",
        onItemClick: () => g(e, x)
      }
    ] : []
  ], B = ee(
    D[U],
    D[f]
  ), j = !x, E = ee(L, P);
  return /* @__PURE__ */ d(
    "div",
    {
      className: N("sds_chat__conversation-option", {
        "sds_chat__conversation-option--active": w,
        "sds_chat__conversation-option--highlight": !w && F,
        "sds_chat__conversation-option--status-change": y
      }),
      onClick: () => n == null ? void 0 : n(e),
      onKeyDown: (G) => {
        G.key === "Enter" && (n == null || n(e));
      },
      onMouseLeave: () => R(!1),
      role: "menuitem",
      tabIndex: 0,
      children: [
        /* @__PURE__ */ d("div", { className: "flex__gap--x-small", style: { flexDirection: "column" }, children: [
          /* @__PURE__ */ d(
            "div",
            {
              className: N("sds_chat__conversation-option__title", {
                "sds_chat__conversation-option__title--highlight": _
              }),
              children: [
                /* @__PURE__ */ s(Be, { seen: !_ }),
                /* @__PURE__ */ s("div", { className: "sds_chat__conversation-option__title__text", children: De(l.subject, T) })
              ]
            }
          ),
          /* @__PURE__ */ d("div", { className: "sds_chat__conversation-option__subtitle", children: [
            `${C} on ${V(D[I])} by `,
            De(B, T)
          ] }),
          z && /* @__PURE__ */ s(
            "div",
            {
              className: N("sds_chat__conversation-option__subtitle", {
                "sds_chat__conversation-option__subtitle__assignment--unassigned": j
              }),
              children: j ? "Unassigned" : `Assigned to ${E}`
            }
          )
        ] }),
        r.length > 0 && /* @__PURE__ */ s(
          "div",
          {
            className: N("sds_chat__conversation-option__options-button", {
              "sds_chat__conversation-option__options-button--show": F
            }),
            children: /* @__PURE__ */ s(
              q,
              {
                isOpen: F,
                menuItemArray: r,
                onInteraction: (G, Y) => {
                  Y == null || Y.stopPropagation(), R(G);
                },
                children: /* @__PURE__ */ s(
                  h,
                  {
                    icon: S.MORE,
                    intent: h.Intent.SECONDARY,
                    title: "Conversation Menu",
                    className: "sds_chat__ellipsis"
                  }
                )
              }
            )
          }
        )
      ]
    }
  );
}, Os = ({
  isOpen: e,
  parentInstanceName: t,
  conversation: a = void 0,
  onCancel: l,
  onConfirm: i
}) => {
  const { statusChangeActionName: n, statusChangeAction: _ } = a != null && a.conversationStatus ? ie[a.conversationStatus] : { statusChangeActionName: "", statusChangeAction: "" };
  return /* @__PURE__ */ s(
    ts,
    {
      dialogTitle: `Confirm ${n} ${t}`,
      isOpen: e,
      dialogContent: /* @__PURE__ */ d(k, { children: [
        /* @__PURE__ */ s("div", { className: N("padding__bottom--medium"), children: `Are you sure you want to ${n} this ${t}?` }),
        /* @__PURE__ */ s("div", { className: "padding__bottom--small", children: a && /* @__PURE__ */ s(
          Ge,
          {
            ...a,
            conversationStatus: a.conversationStatus,
            parentInstanceName: t,
            isStatusChangePreview: !0
          }
        ) })
      ] }),
      primaryButtonLabel: `Yes, ${n} ${t}`,
      primaryButtonIntent: K.Intent.PRIMARY,
      secondaryButtonLabel: "No, return to referral details",
      onSecondaryButtonClick: l,
      onPrimaryButtonClick: () => i(a == null ? void 0 : a.conversationId, _),
      canEscapeKeyClose: !0
    }
  );
}, Ds = ({
  title: e,
  children: t = void 0,
  sectionKey: a,
  onlyOpenKey: l = void 0,
  setOnlyOpenKey: i
}) => {
  const n = a === l, _ = () => {
    i(a === l ? void 0 : a);
  };
  return /* @__PURE__ */ d("div", { className: "sds_collapsible-section sds_chat__conversation-pane__section", children: [
    /* @__PURE__ */ d("div", { className: "sds_collapsible-section__header", children: [
      /* @__PURE__ */ s("span", { className: "sds_collapsible-section__header__title sds_collapsible-section__header__title--fill", children: e }),
      /* @__PURE__ */ s(
        rs,
        {
          className: N("sds_collapsible-section__header__chevron", {
            "sds_collapsible-section__header__chevron--up": n
          }),
          icon: S.CHEVRON_DOWN,
          title: `${n ? "Close" : "Open"} Section`,
          onClick: _
        }
      )
    ] }),
    /* @__PURE__ */ s(
      he,
      {
        "data-testid": "animate-height",
        duration: 300,
        height: n ? "auto" : 0,
        className: "sds_chat__conversation-pane__options",
        children: t
      }
    )
  ] });
}, Ie = ({
  conversations: e = void 0,
  selectedConversation: t = void 0,
  onConversationSelect: a = void 0,
  onMessageSend: l,
  onNewConversationClick: i = void 0,
  onConversationDelete: n = void 0,
  onMessageDelete: _,
  conversationType: u = W.CHAT,
  onSearch: c,
  highlightText: p,
  mentionOnClick: g,
  attachOnClick: T,
  chatDisabled: y,
  chatLoading: z = void 0,
  userUPN: x,
  isSupportUser: L,
  onConversationStatusChange: P = void 0,
  onChangeConversationType: D,
  onChangeAssignment: F,
  showViewDetailsButton: R,
  chatLinkGenerator: w = void 0
}) => {
  const [H, C] = M(), [I, U] = M(), f = Z(
    () => (
      // Spread to avoid sorting immutable objects
      [...e ?? []].sort(
        (o, v) => (
          // want it in descending order
          ve(v.lastUpdated, o.lastUpdated)
        )
      )
    ),
    [e]
  ), r = Ue[u], { defaultConversation: B, groups: j } = Ns(
    f,
    r.groupByStatus
  ), [E, G] = M(
    t ?? B
  ), [Y, se] = M(O.OPEN);
  le(() => {
    t && (G(t), se(t == null ? void 0 : t.conversationStatus));
  }, [t]);
  const te = P ? (o) => {
    U(
      f.find((v) => v.conversationId === o)
    );
  } : void 0, oe = (o) => /* @__PURE__ */ s(
    Ge,
    {
      ...o,
      onClick: (v) => {
        a ? a == null || a(v) : G(
          f.find((pe) => pe.conversationId === v)
        );
      },
      selectedOption: E == null ? void 0 : E.conversationId,
      onDelete: n,
      highlightText: p,
      parentInstanceName: r.parentInstanceName,
      onStatusChange: te,
      onChangeConversationType: D,
      onChangeAssignment: F,
      conversationStatus: r.onlyOpenStatuses ? O.OPEN : o.conversationStatus,
      showAssignee: r.showAssignee && L
    },
    o.conversationId
  ), b = (o, v) => o.length > 0 ? o.map(oe) : /* @__PURE__ */ s(
    "div",
    {
      className: N("sds_chat__no-conversation-message", {
        "padding__top--medium": !!v
      }),
      children: /* @__PURE__ */ s("span", { className: "sds_chat__no-conversation-message__text", children: v ? `No ${v} ${r.parentInstanceName}s.` : `No ${r.parentInstanceName}s available.` })
    }
  );
  return /* @__PURE__ */ d(k, { children: [
    P && /* @__PURE__ */ s(
      Os,
      {
        isOpen: !!I,
        parentInstanceName: r.parentInstanceName,
        conversation: I,
        onCancel: () => U(void 0),
        onConfirm: (o, v) => {
          P == null || P(o, v), U(void 0);
        }
      }
    ),
    /* @__PURE__ */ s("div", { className: "sds_chat", children: /* @__PURE__ */ s(
      Fe,
      {
        sidebarHeaderContent: {
          minimized: /* @__PURE__ */ s(
            h,
            {
              icon: r.parentInstanceIcon,
              size: 16,
              className: "padding__around--small"
            }
          ),
          expanded: /* @__PURE__ */ d(k, { children: [
            /* @__PURE__ */ s("span", { className: "sds_filter-sidebar__header-text", children: `${r.parentInstanceName}s` }),
            /* @__PURE__ */ s(
              h,
              {
                icon: S.PLUS,
                size: 20,
                onClick: i,
                className: N(
                  "sds_chat__button",
                  "sds_chat__button--primary",
                  "padding__right--x-small",
                  { "sds_chat__button--disabled": !i }
                )
              }
            )
          ] })
        },
        sidebarContent: /* @__PURE__ */ d("div", { className: "sds_chat__conversation-pane", children: [
          /* @__PURE__ */ s(
            os,
            {
              className: "margin__around--medium",
              value: H,
              onSearch: (o) => {
                C(o), c == null || c(o);
              }
            }
          ),
          /* @__PURE__ */ s(
            "div",
            {
              className: N({
                "sds_chat__conversation-pane__options": !r.groupByStatus,
                "sds_chat__conversation-pane__sections": r.groupByStatus
              }),
              children: r.groupByStatus ? /* @__PURE__ */ s(k, { children: ps.map((o) => {
                var v;
                return /* @__PURE__ */ s(
                  Ds,
                  {
                    title: `${de(
                      o
                    )} Conversations (${j[o].length})`,
                    sectionKey: o,
                    onlyOpenKey: Y,
                    setOnlyOpenKey: se,
                    children: b(
                      j[o],
                      (v = ie[o]) == null ? void 0 : v.descriptor
                    )
                  },
                  o
                );
              }) }) : b(f)
            }
          )
        ] }),
        mainContent: f.length > 0 ? /* @__PURE__ */ s(
          He,
          {
            currentChat: E,
            onMessageSend: l,
            onMessageDelete: _,
            messageContainer: r.childContainer,
            mentionOnClick: g,
            attachOnClick: T,
            chatDisabled: y ?? ((E == null ? void 0 : E.conversationStatus) && E.conversationStatus !== O.OPEN),
            newInstanceImage: r.newInstanceImage,
            newInstancePrimaryText: r.newInstancePrimaryText(
              E == null ? void 0 : E.createdBySupportUser
            ),
            newInstanceSecondaryText: r.newInstanceSecondaryText(
              E == null ? void 0 : E.createdBySupportUser
            ),
            childInstanceName: r.childInstanceName,
            isLoading: z,
            userUPN: x,
            isSupportUser: L,
            showDateSeparators: r.showDateSeparators,
            onConversationStatusChange: te,
            onChangeConversationType: D,
            onChangeAssignment: F,
            showViewDetailsButton: R,
            chatLink: w ? w(E) : void 0
          }
        ) : /* @__PURE__ */ s(
          we,
          {
            sectionTitle: "",
            className: "sds_chat__window",
            content: /* @__PURE__ */ s(
              ce,
              {
                className: "sds_chat__window--empty",
                icon: /* @__PURE__ */ s(
                  "img",
                  {
                    src: r.noInstanceImage,
                    alt: "No Instance",
                    loading: "lazy"
                  }
                ),
                size: ce.Sizes.LARGE,
                primaryText: r.noInstancePrimaryText,
                secondaryText: r.noInstanceSecondaryText
              }
            )
          }
        )
      }
    ) })
  ] });
};
Ie.ConversationType = W;
Ie.ConversationStatus = O;
Ie.MessageType = me;
const bs = ({ isOpen: e, onClose: t, onAddFile: a }) => {
  const l = ne.object({
    attachFile: Re.validator().required(ue.requiredField.errorMessage).length(1, ue.requiredField.errorMessage)
  });
  return /* @__PURE__ */ s(
    ge,
    {
      initialValues: { file: void 0, attachFile: [] },
      enableReinitialize: !0,
      validateOnMount: !0,
      validationSchema: l,
      onSubmit: async (i, { resetForm: n }) => {
        await a({ file: i.file }), n(), t();
      },
      children: (i) => /* @__PURE__ */ s(
        Le,
        {
          dialogTitle: "Add File",
          isOpen: e,
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: () => {
            t(), i.resetForm();
          },
          primaryButtonLabel: "Add File",
          isPrimaryButtonDisabled: !i.isValid || i.isSubmitting,
          dialogContent: /* @__PURE__ */ s(
            Re,
            {
              id: "attachFile",
              label: "Attach File",
              required: !0,
              verticalSpacingSmall: !0,
              accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/pdf",
              helperText: "Accepted file types: xlsx, docx, csv, and pdf",
              maxAllowedFiles: 1,
              onAddFiles: async (n) => {
                await i.setFieldValue("file", n == null ? void 0 : n[0]);
              },
              onRemoveFile: async () => {
                await i.setFieldValue("file", void 0);
              }
            }
          )
        }
      )
    }
  );
}, Ms = ({
  request: e = void 0,
  treatmentUrlBase: t,
  requestUrlBase: a,
  onFileDownloadClick: l,
  onAddFile: i,
  disabled: n = !1
}) => {
  const [_, u] = M(!1), c = (e == null ? void 0 : e.requestType) === X.ESCALATION || [fe.PRODUCT, fe.PHARMACY].includes(
    (e == null ? void 0 : e.requestSubType) ?? ""
  ) ? "Additional Notes" : "Description";
  return /* @__PURE__ */ d("div", { className: "sds_request-pane", children: [
    /* @__PURE__ */ s(
      bs,
      {
        isOpen: _,
        onClose: () => u(!1),
        onAddFile: i
      }
    ),
    (e == null ? void 0 : e.requestType) === X.ESCALATION && /* @__PURE__ */ d("div", { children: [
      /* @__PURE__ */ s("div", { className: "sds_request-pane__label", children: "Attached Treatments" }),
      e.treatments && e.treatments.length > 0 ? /* @__PURE__ */ s("div", { className: "flex__gap--large", style: { flexDirection: "column" }, children: e.treatments.map((p) => /* @__PURE__ */ d(
        "div",
        {
          className: "flex__gap--small",
          style: { flexDirection: "column" },
          children: [
            /* @__PURE__ */ s(
              Q,
              {
                label: "Product",
                value: p.productServiceDescription
              }
            ),
            /* @__PURE__ */ s(
              ye,
              {
                navUrl: `${t}${p.treatmentId}`,
                openInNewTab: !0,
                linkText: /* @__PURE__ */ s(
                  ae,
                  {
                    label: "View Treatment",
                    rightIcon: t.startsWith("http") ? S.SHARE : void 0
                  }
                )
              }
            )
          ]
        },
        p.treatmentId
      )) }) : /* @__PURE__ */ s("div", { className: "sds_request-pane__label--no-results", children: "No treatments attached." })
    ] }),
    /* @__PURE__ */ d("div", { children: [
      /* @__PURE__ */ s("div", { className: "sds_request-pane__label", children: c }),
      e != null && e.additionalNotes ? /* @__PURE__ */ s("div", { children: e.additionalNotes }) : /* @__PURE__ */ d("div", { className: "sds_request-pane__label--no-results", children: [
        "No ",
        c,
        " provided."
      ] })
    ] }),
    /* @__PURE__ */ d("div", { children: [
      /* @__PURE__ */ s("div", { className: "sds_request-pane__label", children: "Attached Files" }),
      e != null && e.attachments && e.attachments.length > 0 ? /* @__PURE__ */ s("div", { className: "flex__gap--medium", style: { flexDirection: "column" }, children: e.attachments.map((p) => /* @__PURE__ */ d(
        "div",
        {
          style: { display: "flex", flexDirection: "column" },
          children: [
            /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(
              ae,
              {
                className: "sds_request-pane__attachment",
                rightIcon: S.DOWNLOAD,
                onClick: () => {
                  l(p);
                },
                label: /* @__PURE__ */ s("span", { className: "sds_request-pane__attachment--filename", children: p.filename })
              }
            ) }),
            /* @__PURE__ */ s("div", { className: "sds_request-pane__attachment--date", children: `Date Added: ${V(
              p.dateAdded,
              $.DATE_TIME
            )}` })
          ]
        },
        p.requestAttachmentId
      )) }) : /* @__PURE__ */ s("div", { className: "sds_request-pane__label--no-results", children: "No files attached." }),
      e && !Ve(e) && e.requestStatus !== re.Statuses.RESOLVED && /* @__PURE__ */ s(
        ae,
        {
          className: "margin__top--small",
          leftIcon: S.ADD,
          label: "Add File",
          onClick: () => u(!0),
          disabled: n
        }
      )
    ] }),
    (e == null ? void 0 : e.reopenedFromRequestId) && /* @__PURE__ */ d("div", { children: [
      /* @__PURE__ */ s("div", { className: "sds_request-pane__label", children: "Original Request" }),
      /* @__PURE__ */ s(
        ye,
        {
          navUrl: `${a}${e.reopenedFromRequestId}`,
          openInNewTab: !0,
          linkText: e.reopenedFromRequestNumber
        }
      )
    ] }),
    (e == null ? void 0 : e.issueSource) && /* @__PURE__ */ d("div", { className: "flex__gap--small", style: { flexDirection: "column" }, children: [
      /* @__PURE__ */ s("div", { className: "sds_request-pane__label", children: "Root Cause" }),
      /* @__PURE__ */ s(Q, { label: "Issue Source", value: e.issueSource }),
      /* @__PURE__ */ s(
        Q,
        {
          label: "Primary Issue Description",
          value: e.primaryIssueDescription
        }
      ),
      /* @__PURE__ */ s(
        Q,
        {
          label: "Secondary Issue Description",
          value: e.secondaryIssueDescription
        }
      )
    ] })
  ] });
}, Ps = ({
  requestId: e,
  request: t,
  notesForRequest: a = void 0,
  treatmentUrlBase: l,
  requestUrlBase: i,
  onFileDownloadClick: n,
  onMessageSend: _,
  onApprovalComplete: u,
  onMessageDelete: c,
  onAddFile: p,
  conversationType: g = W.CHAT,
  disabled: T = !1,
  isLoading: y = !1,
  userUPN: z,
  isSupportUser: x = !1
}) => {
  const L = Z(() => {
    var H, C;
    const [R, w] = ((H = t == null ? void 0 : t.submitterFullName) == null ? void 0 : H.split(" ")) ?? [];
    return t ? {
      ...t,
      createdTime: t.createDate,
      conversationId: t.requestId,
      createdByFirstName: R,
      createdByLastName: w,
      details: { subject: "Request Activity" },
      messages: (C = t == null ? void 0 : t.activity) == null ? void 0 : C.map((I) => {
        var B;
        const [U, f] = ((B = I.actorFullName) == null ? void 0 : B.split(" ")) ?? [];
        let r = I.actionDetail;
        return I.actionType === m.ASSIGN_UP && r == null || I.actionType === m.ASSIGN_CL && r == null ? r = "unassigned" : [
          m.MESSAGE,
          m.APPROV_REQ,
          m.APPROV_DEN,
          m.ASSIGN_UP,
          m.ASSIGN_CL
        ].includes(I.actionType) || (r = void 0), {
          messageId: I.requestActivityId,
          senderFirstName: U,
          senderLastName: f,
          content: { message: r, status: I.actionType },
          sentTime: I.actionDate,
          upn: I.actorUpn,
          isSupportMsg: I.fmhAction,
          messageType: I.actionType === m.MESSAGE ? me.NORMAL : me.SYSTEM
        };
      })
    } : void 0;
  }, [t]), P = Z(
    () => ({
      conversationId: "NOTES",
      details: { subject: "Notes" },
      messages: a == null ? void 0 : a.map((R) => {
        var C;
        const [w, H] = ((C = R.senderFullName) == null ? void 0 : C.split(" ")) ?? [];
        return {
          messageId: R.requestNoteId,
          content: { message: R.requestNote },
          upn: R.upn,
          senderFirstName: w,
          senderLastName: H,
          sentTime: R.sentTime
        };
      })
    }),
    [a]
  ), D = Ue[g], F = g === W.NOTES ? P : L ?? {
    // Default loading state
    conversationId: e,
    details: { subject: "Request Activity" }
  };
  return /* @__PURE__ */ s("div", { className: "sds_chat", children: /* @__PURE__ */ s(
    Fe,
    {
      sidebarHeaderContent: {
        expanded: /* @__PURE__ */ s("div", { className: "sds_request-pane__header", children: "Request Details" })
      },
      sidebarContent: /* @__PURE__ */ s(
        Ms,
        {
          request: L,
          treatmentUrlBase: l,
          requestUrlBase: i,
          onFileDownloadClick: n,
          onAddFile: p,
          disabled: T
        }
      ),
      mainContent: /* @__PURE__ */ s(
        He,
        {
          currentChat: F,
          onMessageSend: _,
          onMessageDelete: c,
          onApprovalComplete: u,
          messageContainer: D.childContainer,
          chatDisabled: T,
          childInstanceName: D.childInstanceName,
          isLoading: y,
          userUPN: z,
          isSupportUser: x,
          showDateSeparators: D.showDateSeparators
        }
      )
    }
  ) });
};
Ps.ConversationType = W;
const ws = (e, t) => `This referral has ${e} open conversation${J(
  e > 1,
  "s"
)}${J(
  t > 0,
  ` and ${t} unread message${J(t > 1, "s")}`
)}.`, mt = ({
  openConversations: e = 0,
  unreadMessages: t = 0
}) => e > 0 ? /* @__PURE__ */ d("span", { className: "sds_chat-icon", children: [
  /* @__PURE__ */ s(
    h,
    {
      icon: S.CHAT,
      intent: h.Intent.DEFAULT,
      title: "Messages",
      tooltipContent: ws(e, t)
    }
  ),
  t > 0 && /* @__PURE__ */ s("div", { className: "sds_chat-icon--unread-messages" })
] }) : null, pt = ({ isUnread: e = !1 }) => e ? /* @__PURE__ */ d("span", { className: "sds_chat-icon", children: [
  /* @__PURE__ */ s(
    h,
    {
      icon: S.CHAT,
      intent: h.Intent.DEFAULT,
      title: "Messages",
      tooltipContent: "Your organization has unread messages for this request."
    }
  ),
  /* @__PURE__ */ s("div", { className: "sds_chat-icon--unread-messages" })
] }) : null, ut = ({ requests: e = [] }) => e.length > 0 ? /* @__PURE__ */ s(
  h,
  {
    icon: S.INBOX,
    intent: h.Intent.DEFAULT,
    title: "Requests",
    tooltipContent: /* @__PURE__ */ s("div", { className: "sds_treatment-requests-icon", children: e.map((t) => /* @__PURE__ */ d("div", { children: [
      /* @__PURE__ */ s("div", { className: "sds_treatment-requests-icon__header", children: `Request # ${t.requestNumber}` }),
      /* @__PURE__ */ s("div", { className: "sds_treatment-requests-icon__value", children: `Request Type: ${t.requestSubType}` }),
      /* @__PURE__ */ s("div", { className: "sds_treatment-requests-icon__value", children: `Status: ${re.StatusMessages[t.requestStatus]}` }),
      t.assignedFullName && /* @__PURE__ */ s("div", { className: "sds_treatment-requests-icon__value", children: `Assigned To: ${t.assignedFullName}` }),
      /* @__PURE__ */ s("div", { className: "sds_treatment-requests-icon__value", children: Ve(t) ? `Completed on: ${V(
        t.completedDate,
        $.DATE_TIME
      )}` : `Created on: ${V(
        t.createDate,
        $.DATE_TIME
      )}` })
    ] }, t.requestId)) })
  }
) : null, be = 12, Nt = ({
  upn: e = void 0,
  fullName: t = void 0,
  small: a = !1
}) => e ? /* @__PURE__ */ d("div", { className: "sds_user-cell", children: [
  /* @__PURE__ */ s("div", { className: "sds_user-cell__icon", children: e.endsWith("@freemarkethealth.com") ? /* @__PURE__ */ s(xe, { size: be }) : /* @__PURE__ */ s(h, { icon: S.OFFICE, intent: h.Intent.DEFAULT, size: be }) }),
  /* @__PURE__ */ s(
    ms,
    {
      className: N("sds_user-cell__text", {
        "sds_user-cell__text--small": a
      }),
      content: e,
      children: t ?? e
    }
  )
] }) : null;
export {
  fe as ChangeRequestSubType,
  He as ChatWindow,
  Ie as ChatWithConversationPane,
  Ps as ChatWithRequestPane,
  rt as MemberEscalationSubType,
  fs as NoteMessage,
  mt as ReferralChatIcon,
  m as RequestActionType,
  pt as RequestChatIcon,
  X as RequestType,
  _t as RequestTypeDisplayTextMap,
  Be as SeenIndicator,
  ut as TreatmentRequestsIcon,
  Nt as UserCell,
  Ee as UserImage,
  Ns as getDefaultConversation,
  Ve as isRequestArchived
};
//# sourceMappingURL=index.js.map
